import { Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';

@Injectable()
export class CustomDateFnsAdapter extends DateFnsAdapter {
  override parse(value: string, parseFormat: string | string[]): Date | null {
    const result = super.parse(value, parseFormat);

    if (result && result.getFullYear() < 100) {
      result.setFullYear(2000 + result.getFullYear());
    }

    return result;
  }
}
